'use strict'

const pools = {
  1: [
    {
      address: '0x3364f53cB866762Aef66DeEF2a6b1a17C1F17f46',
      mainPool: true,
      name: 'Main Pool'
    },
    {
      address: '0x574a32f1047C631653D9283d36e73cF9BA67B940',
      mainPool: false,
      name: 'Test Pool'
    }
  ],
  10: [
    {
      address: '0x6394152946dc3E0bABAA474eE9d366ef31f959c0',
      mainPool: true,
      name: 'Main Pool'
    }
  ],
  8453: [
    {
      address: '0xc614136d6c5AB85bc2aCF0ec2652351642d7F54E',
      mainPool: true,
      name: 'Main Pool'
    }
  ]
}

module.exports = pools
